import { api } from "@/api";
import type {
  GetCompanyResponse,
  GetProfileResponse,
  UpdateCompanyRequest,
} from "./companyTypes";

const getCompanies = async (): Promise<GetCompanyResponse[]> => {
  const response = await api.get<GetCompanyResponse[]>(`v1/companies`);

  return response.data;
};

const getProfile = async (companyId: string): Promise<GetProfileResponse> => {
  const response = await api.get<GetProfileResponse>(
    `v1/companies/${companyId}/profile`
  );

  return response.data;
};

const updateProfile = async (data: UpdateCompanyRequest) => {
  await api.put(`v1/companies/${data.companyId}/profile`, {
    identifier: data.identifier,
    name: data.name,
    whatsapp_status: data.whatsapp_status,
    email: data.email,
    address: data.address,
    site: data.site,
    main_phone: data.main_phone,
    cnpj: data.cnpj,
  });
};

const updatePhoto = async (companyId: string, base64: string) => {
  await api.put(`v1/companies/${companyId}/profile-picture`, { base64 });
};

export const companyService = {
  updatePhoto,
  getProfile,
  getCompanies,
  updateProfile,
};
